var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1162 0.247193C31.1162 0.247193 34.2453 -0.96481 33.9846 1.97863C33.8976 3.19063 33.2023 7.43264 32.5069 12.0209C31.4638 18.5138 30.3339 25.6127 30.3339 25.6127C30.3339 25.6127 30.16 27.6038 28.6824 27.9501C27.2047 28.2964 24.7709 26.7381 24.3363 26.3918C23.9886 26.1321 17.8172 22.2364 15.5573 20.3318C14.9488 19.8124 14.2534 18.7735 15.6442 17.5615C18.7733 14.7047 22.511 11.1552 24.7709 8.90436C25.814 7.8655 26.857 5.44149 22.511 8.38493C16.3395 12.6269 10.2551 16.6092 10.2551 16.6092C10.2551 16.6092 8.86431 17.475 6.25667 16.6958C3.64904 15.9167 0.606792 14.8778 0.606792 14.8778C0.606792 14.8778 -1.47932 13.5792 2.08445 12.1941C2.08445 12.1941 17.1218 6.0475 22.3371 3.8832C24.3363 3.01749 31.1162 0.247193 31.1162 0.247193Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.295f95f0247a059c0b7585e6c6956459.svg";
export { ForwardRef as ReactComponent };